var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"work-layout"},[_c('work-menu'),_c('a-layout-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }